import React from "react";
import { Table } from "antd";

const Index = props => {
  const {
    pageInfo,
    columns,
    list,
    rowKey,
    onItemClick,
    onPageChange,
    hidePagination,
    selfPageNation = {},
    ...otherProps
  } = props;

  const { page, totalElements } = pageInfo || {};

  // 分页器属性
  const pagination =
    hidePagination === true
      ? false
      : {
          showQuickJumper: true,
          showSizeChanger: true,
          defaultCurrent: page,
          current: page,
          defaultPageSize: 10,
          total: totalElements,
          onShowSizeChange: onPageChange,
          onChange: onPageChange,
          showTotal: () => `共 ${totalElements} 条记录`,
          ...selfPageNation
        };

  return (
    <Table
      scroll={{ x: "max-content" }}
      onRow={record => ({
        onClick: () => {
          if (onItemClick) {
            onItemClick(record.id, record); // 点击行
          }
        }
      })}
      columns={columns}
      dataSource={list}
      pagination={pagination}
      rowKey={rowKey}
      {...otherProps}
    />
  );
};

export default Index;
